import { AuthPanel } from "@/ui/AuthPanel"

export const Login = () => <AuthPanel mode="login" />
